import {addDays, subDays, differenceInCalendarDays, differenceInMinutes} from 'date-fns'
import { pluck, length, equals, reduce, pipe, filter, propEq, forEach, prop } from 'ramda'
import addWorkerCtrl from '../../manager-app/workforce/managerWorkforce.ctrl'
import addWorkerTpl from '../../manager-app/workforce/managerWorkforce.html'
const today = new Date()
let dateCutoff = subDays(today, 3)
let futureDateCutoff = addDays(today, 2)
import moment from 'moment-timezone'

const getSelected = filter(propEq('selected', true))

const mask = (a, b) => a | b

const encodeDayMask = pipe(
  getSelected,
  pluck('value'),
  reduce(mask, 0)
)

const decodeDayMask = (dayMask, days) => {
  forEach((day) => {
    if (equals(day.value & dayMask, day.value)) {
      day.selected = true
    }
  }, days)
}

const getJobDay = (date) => {
  return prop(moment(date).format('YYYY-MM-DD'))
}

class showEditSchedule {
  /* @ngInject */
  constructor ($mdDialog, $mdToast, Jobs, Users, ToastService, $scope, Companies, Crews, company, $templateCache, $filter) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$templateCache = $templateCache
    this.Jobs = Jobs
    this.Users = Users
    this.Companies = Companies
    this.ToastService = ToastService
    this.Crews = Crews
    this.addToJob = 'add'
    this.$scope = $scope
    this.showLoaderCircle = false
    this.loadingWorkers = false
    this.showShiftDays = false
    this.company = company
    this.$filter = $filter
    this.days = [
      { name: 'Su', value: 1 },
      { name: 'M', value: 2 },
      { name: 'T', value: 4 },
      { name: 'W', value: 8 },
      { name: 'Th', value: 16 },
      { name: 'F', value: 32 },
      { name: 'S', value: 64 }
    ]

    this.selectedDates = []

    this.getCompanyJobs()
  }

  getCompanyJobs () {
    this.showLoaderCircle = true
    this.Jobs.companyJobs(this.company.internal_id, dateCutoff, futureDateCutoff)
      .then((data) => {
        this.shifts = data.shifts
        this.jobs = data.jobs
        decodeDayMask(this.jobs.days, this.days)
        this.myCrews = this.Crews.getCrews()
        this.myWorkforce = this.Users.fetchOtherWorkforce(this.company.internal_id)
        .then(this.hideLoader())
      })
  }

  dayClick (date) {
    console.log("You clicked " + this.$filter("date")(date, "MMM d, y h:mm:ss a Z"))
  }

  setDayContent (date) {
    return (date) => {
      let shiftsData = getJobDay(date)(this.schedule.days)
      let numJobs = length(keys(shiftsData)) || ''
      let jobName = ''
      let isDirectHire = false
      let isStarting = false
      let isAppStarting = false
      let reoccuring = false
      for (let jobId in shiftsData) {
        var jobData = prop(jobId, this.schedule.jobs)
        var shiftData = shiftsData[jobId]
        if (!numJobs) return
        if (this.direction === 'vertical') {
          jobName += '<div style="padding: 4px; border-left: 3px solid; width:auto;"  style="border-color: ' + jobData.avatarColor + '"><span>' + jobData.title + '<md-icon style="width:auto; min-height:auto; min-width:auto; height:auto;">access_time</md-icon>' + moment(shiftData.startTime).format('hh:mma') + ' - ' + moment(shiftData.endTime).format('hh:mma') + '</span></div>'
        } else {
          if (!jobData.isApplication && shiftData.shift === 0) { isStarting = true } else { reoccuring = true }
          if (jobData.isApplication && shiftData.shift === 0 && jobData.currentlyOnJob < jobData.needed) {
            isAppStarting = true
            if (moment(date).isAfter(moment()) && moment(date).isBefore(moment().add(3, 'days'))) {
              this.applicationAlert.push(jobId)
              this.applicationAlert = uniq(this.applicationAlert)
            }
          }
          if ((jobData.isDirectHire || jobData.isCrewOnly) && shiftData.shift === 0 && jobData.currentlyOnJob < jobData.needed) {
            isDirectHire = true
            if (moment(date).isAfter(moment()) && moment(date).isBefore(moment().add(3, 'days'))) {
              this.directHireAlert.push(jobId)
              this.directHireAlert = uniq(this.directHireAlert)
            }
          }
        }
      }
      if (reoccuring && !isStarting) { jobName += '<i style="margin-left:2px"></i><div style="border: solid 1px #bbbbbb; border-radius: 50%; width: 5px; height: 5px;"></div>' }
      if (isStarting) { jobName += '<i style="margin-left:2px"></i><div style="background-color: #bbbbbb; border-radius: 50%; width: 5px; height: 5px;"></div>' }
      if (isAppStarting) { jobName += '<i style="margin-left:2px"></i><div style="background-color: #3246F0; border-radius: 50%; width: 5px; height: 5px;"></div>' }
      if (isDirectHire) { jobName += '<i style="margin-left:2px"></i><div style="background-color: #3246F0; border-radius: 50%; width: 5px; height: 5px;"></div>' }
      return jobName
    }
  }

  

  showLoader () {
    this.showLoaderCircle = true
  }

  hideLoader () {
    this.loadingWorkers = false
    this.showLoaderCircle = false
  }

  createNewShift (job) {
    this.repost = true
    this.jobToRepost = job
    this.now = new Date()
    this.startDate = new Date()
    let shiftStartMinute = moment(job.start_date).get('minute')
    let shiftStartHour = moment(job.start_date).get('hour')
    let startTime = moment(this.startDate).set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).format()
    this.startTime = new Date(startTime)
    this.endDate = new Date()
    let shiftEndMinute = moment(job.end_date).get('minute')
    let shiftEndHour = moment(job.end_date).get('hour')
    let endTime = moment(this.endDate).set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).format()
    this.endTime = new Date(endTime)
  }

  handleOverlap (e) {
    if (!e.status || e.status !== 409) throw e
    let text
    let title

    const users = pipe(
      prop('reason'),
      JSON.parse,
      pluck('name')
    )(e.data)

    title = users + ' has a conflicting shift. Continue putting them on the job anyways?'

    const confirm = this.$mdDialog.confirm()
      .title(title)
      .multiple(true)
      .textContent(text)
      .ariaLabel('Conflict confirm')
      .ok('Yes')
      .cancel('No')

    return this.$mdDialog.show(confirm)
  }

  updateSchedule () {
    this.Jobs.scheduleChange(jobId, {
      userIds: [120],
      reason: '' || null,
      message: '' || null,
      schedule: {
        startTime: '9:00 AM',
        endTime: '5:00 PM',
        days: 127,
        startDate: '2019-06-01',
        endDate: '2019-10-01'
      },
      exceptions: [{
        startDate: '2019-06-02',
        startTime: '10:00 AM',
        endDate: '2019-06-10',
        endTime: '04:00 PM',
        days: 127
      }, {
        startDate: '2019-07-04',
        startTime: '10:00 AM',
        endDate: '2019-07-04',
        endTime: '04:00 PM',
        days: 0
      }],
      getConfirmations: true
    })
  }

  showAddWorker (job, selectedShift) {

    this.errors = []
    this.addForm.timeForm.$error = false
    this.addForm.$invalid = false
    this.loadingWorkers = true
    let shiftStartMinute = moment(this.startTime).get('minute')
    let shiftStartHour = moment(this.startTime).get('hour')
    let repostStartObj = moment(this.startDate).set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0})
    let repostStartTime = repostStartObj.format()
    let shiftEndMinute = moment(this.endTime).get('minute')
    let shiftEndHour = moment(this.endTime).get('hour')
    let repostEndObj = moment(this.endDate).set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0})
    let repostEndTime = repostEndObj.format()
    let diff = repostEndObj.diff(repostStartObj, 'hours', true)

    if (differenceInCalendarDays(this.startDate, this.endDate) > 0) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('End date is before start date')
    }

    let shiftDuration = differenceInMinutes(this.endTime, this.startTime, ) / 60
    if (differenceInCalendarDays(this.endDate, this.startDate) > 0  && shiftDuration < 0) {
      shiftDuration = shiftDuration + 24
    }

    if (shiftDuration < 0) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift start time must before end time')
    } else if (4 > shiftDuration > 0 ) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift must be at least 4 hours')
    } else if (shiftDuration >= 14) {
      this.loadingWorkers = false
      return this.ToastService.showWarning('Shift must be under 14 hours')
    }

    if (diff > 20 && !this.showShiftDays) {
      this.showShiftDays = true
      this.loadingWorkers = false
      return this.ToastService.showWarning('Select the days of the week')
    }
    let confirm = {
      controller: addWorkerCtrl,
      controllerAs: 'add',
      template: addWorkerTpl,
      fullscreen: true,
      multiple: true,
      clickOutsideToClose: true,
      locals: {
        job: job,
        Users: this.Users,
        shift: selectedShift,
        workforce: this.myWorkforce,
        repost: this.repost
      },
      onRemoving: () => {
        this.$templateCache.remove(addWorkerTpl)
      }
    }
    this.$mdDialog.show(confirm).then((addedWorkers) => {
      this.loadingWorkers = false
      if (this.repost) {
        this.showLoader()
        let addedWorkerIds = pluck('external_id', addedWorkers)
        let days = 127
        if (this.showShiftDays) {
          days = encodeDayMask(this.days)
        }
        this.Jobs.repost({
          jobId: this.jobToRepost.external_id,
          dsb: 0,
          startDate: repostStartTime,
          endDate: repostEndTime,
          userIds: addedWorkerIds,
          needed: length(addedWorkers),
          days: days
        })
        .then(
          (response) => {
            let newJobId = response.data.externalId
            if (this.addToJob === 'add') {
              this.Users.clientPutOnJob(addedWorkerIds, newJobId)
              .then(() => {
                this.hideLoader()
                const msg = 'Added Employees To The Job!'
                this.$mdToast.showSimple(msg)
                this.showLoginScreen = true
                this.addedWorkers = []
                return this.$mdDialog.hide('reload')
              })
              .catch((err) => {
                if (!err) return
                this.$mdToast.showSimple(err)
              })
            } else if (this.addToJob === 'approve') {
              this.Users.clientPutOnJob(addedWorkerIds, newJobId, null, true)
              .then(() => {
                this.hideLoader()
                const msg = 'Added Employees and Approved Hours'
                this.$mdToast.showSimple(msg)
                this.showLoginScreen = true
                this.addedWorkers = []
                return this.$mdDialog.hide('reload')
              })
              .catch((err) => {
                if (!err) return
                this.$mdToast.showSimple(err)
              })
            } else if (this.addToJob === 'invite') {
              this.hideLoader()
              this.$mdToast.showSimple('Sent Direct Invites')
              this.showLoginScreen = true
              this.addedWorkers = []
              return
            } else {
              return this.$mdToast.showSimple('Error adding shift')
            }
            return
          },
          () => {
            this.hideLoader()
            this.$mdToast.showSimple('Cancelled job repost')
          }
        )
      } else {
        this.hideLoader()
        this.completedAddWorker = true
        this.addedWorkers = addedWorkers
        return
      }
    }, () => { this.loadingWorkers = false })
    .catch(() => { this.loadingWorkers = false })
  }
}

export default showEditSchedule
